import type { ComparisonPage } from './types'

export const saturn: ComparisonPage = {
  slug: 'saturn',
  competitorName: 'Saturn',
  seo: {
    title: 'WealthSpace vs Saturn | UK Financial Adviser Software Comparison 2026',
    description:
      "Compare WealthSpace and Saturn for UK financial advisers. See how WealthSpace's UK-native, adviser-owned platform compares to Saturn's AI features. FCA compliant, privacy-first.",
    keywords:
      'Saturn alternative, WealthSpace vs Saturn, Saturn competitor, UK adviser software, Saturn UK, FCA compliant AI, financial adviser AI comparison, Saturn alternative UK',
  },
  hero: {
    title: 'WealthSpace vs Saturn:',
    titleAccent: 'Which is Right for UK Advisers?',
    subtitle:
      "Both platforms offer AI-powered tools for financial advisers. Here's an honest comparison to help you choose the right solution for your UK practice.",
  },
  comparisonTable: [
    { feature: 'Built for UK FCA Compliance', wealthspace: 'check', competitor: 'Partial' },
    { feature: 'Adviser-Owned Company', wealthspace: 'check', competitor: 'cross' },
    { feature: 'Privacy Layer (PII Stripping)', wealthspace: 'check', competitor: 'cross' },
    { feature: 'AI Suitability Reports', wealthspace: 'check', competitor: 'check' },
    { feature: 'Meeting Transcription', wealthspace: 'check', competitor: 'check' },
    { feature: 'Client Portal with DocuSign', wealthspace: 'check', competitor: 'Limited' },
    { feature: 'Apple Watch & CarPlay', wealthspace: 'check', competitor: 'cross' },
    { feature: 'Voice Notes (Rambles)', wealthspace: 'check', competitor: 'cross' },
    { feature: 'Value of Advice Calculator', wealthspace: 'check', competitor: 'cross' },
    { feature: 'UK-Based Support Team', wealthspace: 'check', competitor: 'cross' },
    { feature: 'Consumer Duty Documentation', wealthspace: 'check', competitor: 'Partial' },
    { feature: 'Transparent Pricing', wealthspace: 'From £125/mo', competitor: 'Varies' },
  ],
  keyDifferences: {
    title: 'Key Differences at a Glance',
    items: [
      {
        title: 'Ownership Model',
        description:
          'WealthSpace is part of the Adviser Equity Group - advisers who use the software own equity. Saturn is VC-backed with different incentives.',
      },
      {
        title: 'UK-Native Design',
        description:
          'WealthSpace is built from scratch for UK FCA requirements. Saturn originated in the US and has been adapted for UK markets.',
      },
      {
        title: 'Privacy Architecture',
        description:
          'WealthSpace uses a proprietary privacy layer that strips PII before AI processing. Your client data stays secure.',
      },
      {
        title: 'All-in-One Platform',
        description:
          'WealthSpace combines reports, portal, transcription, voice notes, and compliance in one platform. No need for multiple subscriptions.',
      },
    ],
  },
  whyChoose: {
    title: 'Why UK Advisers Choose',
    titleAccent: 'WealthSpace',
    intro:
      "If you're comparing Saturn and WealthSpace, here are the key reasons advisers are switching to WealthSpace:",
    items: [
      'FCA-First Compliance: Built specifically for UK regulatory requirements including Consumer Duty, COBS, and MiFID II documentation',
      "Adviser Ownership: You're not just a customer - you're an owner. The Adviser Equity Group means your feedback shapes the product",
      'Privacy by Design: Our unique privacy layer ensures client PII is stripped before any AI processing occurs',
      'Complete Solution: Reports, portal, transcription, voice notes, compliance - all in one subscription',
      'UK Support Team: Real people in the UK who understand FCA requirements and adviser workflows',
      'Voice-First Features: Capture ideas via Apple Watch, CarPlay, or mobile - unique to WealthSpace',
      'Transparent Pricing: From £125/month with no hidden costs, cancel anytime',
    ],
  },
  whenCompetitor: {
    title: 'When Saturn Might Be',
    titleAccent: 'Right For You',
    intro: 'We believe in honest comparisons. Saturn may be a better fit if:',
    items: [
      "You primarily serve US or international clients where FCA compliance isn't critical",
      "You're already invested in Saturn's ecosystem and switching costs are high",
      'You need features specific to US regulatory requirements',
    ],
  },
  cta: {
    title: 'See the Difference Yourself',
    subtitle: 'Book a personalised demo and see how WealthSpace compares. Free. Friendly. No obligation.',
    buttonText: 'Book a Demo',
  },
}
